import documentApi from '../services/api/documentApi';
import { setAlert } from './alerts';

export const ADD_PHOTO = 'PHOTO/ADD_PHOTO';
export const ADD_LOADING_PHOTO = 'PHOTO/ADD_LOADING_PHOTO';
export const REMOVE_LOADING_PHOTO = 'PHOTO/REMOVE_LOADING_PHOTO';
export const ADD_UPLOADED_PHOTO = 'PHOTO/ADD_UPLOADED_PHOTO';
export const CLEAR_UPLOADED_CACHE = 'PHOTO/CLEAR_UPLOADED_CACHE';

export const addPhoto = (photoId, url, size) => ({
    type: ADD_PHOTO,
    photoId,
    url,
    size,
});

export const addLoadingPhoto = (photoId, size) => ({
    type: ADD_LOADING_PHOTO,
    photoId,
    size,
});

export const removeLoadingPhoto = (photoId, size) => ({
    type: REMOVE_LOADING_PHOTO,
    photoId,
    size,
});

export const addUploadedPhoto = (photoId, objectSrc, size) => ({
    type: ADD_UPLOADED_PHOTO,
    photoId,
    objectSrc,
    size
});

export const clearUploadedCache = () => ({
    type: CLEAR_UPLOADED_CACHE,
});

export const downloadDocument =
    (documentId, variant = 'original') =>
    async (dispatch, getState) => {
        const { token } = getState().pages.inspectionDetail;

        try {
            const {
                data: { data },
            } = token
                ? await documentApi.getDocumentByVariantWithToken(
                      documentId,
                      variant,
                      token
                  )
                : await documentApi.getDocumentByVariant(documentId, variant);

            window.open(data);
        } catch ({ response }) {
            dispatch(setAlert('Unable to fetch photo.', 'error'));
        }
    };

export const getPhoto = (documentId, size) => async (dispatch, getState) => {
    try {
        const isLoading =
            getState().models.photo.loading[size].includes(documentId);
        const hasLoaded = getState().models.photo.loaded[size][documentId];

        const shouldRefreshPhoto = !isLoading && !hasLoaded;

        const { token } = getState().pages.inspectionDetail;

        if (shouldRefreshPhoto) {
            dispatch(addLoadingPhoto(documentId, size));
            const {
                data: { data },
            } = token
                ? await documentApi.getDocumentByVariantWithToken(
                      documentId,
                      size,
                      token
                  )
                : await documentApi.getDocumentByVariant(documentId, size);
            dispatch(removeLoadingPhoto(documentId, size));
            dispatch(addPhoto(documentId, data, size));
        }
    } catch ({ response }) {
        dispatch(setAlert('Unable to fetch photo.', 'error'));
    }
};
